module.exports = __webpack_public_path__ + "static/media/ns.a15c314f.jpg";